<template>
  <div class="addAndModify">
    <el-container>
      <el-main ref="main" class="tabWrap">
        <el-tabs  v-model="activeName" style="width: 100%">
          <el-tab-pane label="基本信息" name="Tab1" style="height: 700px;overflow-y: auto">
            <el-form class="dataFormBox" :rules="rules" :inline="true" :model="dataForm">
              <el-row>
                <el-col :span="8">
                  <el-form-item label-width="120px" label="标题：" prop="title">
                    <el-input v-model="dataForm.title" placeholder="请输入标题" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label-width="120px" label="发文字号：">
                    <el-input v-model="dataForm.documentNum" placeholder="请输入发文字号" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label-width="120px" label="发文分类：">
                    <el-select v-model="dataForm.documentTypeId" style="width: 100%;" placeholder="请选择发文分类">
                      <el-option :label="deptItem.name" :value="deptItem.id" v-for="(deptItem,deptIndex) in typeList" :key="'deptItem'+deptIndex"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label-width="120px" label="发文日期：" prop="documentDate">
                    <el-date-picker
                        v-model="dataForm.documentDate"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="请选择发文日期">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="8">
                  <el-form-item label-width="120px" label="拟稿日期：">
                    <el-date-picker
                        v-model="dataForm.documentDraftDate"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="请选择拟稿日期">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label-width="120px" label="核稿日期：">
                    <el-date-picker
                        v-model="dataForm.documentApproveDate"
                        value-format="yyyy-MM-dd"
                        type="date"
                        placeholder="请选择核稿日期">
                    </el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <div class="sendList">
                    <el-form-item
                        label="拟稿部门："
                        label-width="120px"
                        ref="sendListRef"
                        prop="documentDraftDeptJson"
                    >
                      <div class="el-input tag-wrapper">
                        <el-tag
                            v-for="(tag, index) in dataForm.documentDraftDeptJson"
                            @close="closeAttend(tag)"
                            :key="index"
                            closable
                            style="margin-right: 5px;"
                        >{{ tag.name }}</el-tag
                        >
                      </div>
                      <el-button @click="selectParticipanceList('attendDepart')" type="primary"
                      >选择</el-button
                      >
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="24">
                  <div class="sendList">
                    <el-form-item
                            label="接收人："
                            label-width="120px"
                            ref="sendListRef"
                            prop="documentDraftDeptJson"
                    >
                      <div class="el-input tag-wrapper">
                        <el-tag
                                style="margin-right: 5px;"
                        >综合办</el-tag
                        >
                      </div>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="24">
                  <el-form-item class="maxWidth" label-width="120px" label="备注：">
                    <el-input v-model="dataForm.remark" placeholder="请输入备注信息" clearable></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
          <el-tab-pane label="附件" name="Tab2" style="height: 700px;overflow-y: auto">
            <upload-file
                :tableList="fileList"
                @submit="doSubmitFiles">
            </upload-file>
          </el-tab-pane>
        </el-tabs>
      </el-main>
      <el-footer class="container">
        <div class="btnMid">
          <el-button type="info" @click="close()">关闭</el-button>
          <el-button v-if="documentType == 1" type="info" @click="submitForm()">保存</el-button>
          <el-button v-if="documentType == 2" type="info" @click="submitForm()">修改</el-button>
        </div>
      </el-footer>
    </el-container>

    <select-dialog
        :visible="selectDialogVisible"
        @close="selectDialogClose"
        title="选择"
        v-bind="selectDialogOptions"
    />
    <select-all-dialog
            :visible="selectAllDialogVisible"
            :btnIndex ='btnIndex'
            @close="selectAllDialogClose"
            @setBtnIndex="setBtnIndex"
            title="选择"
            v-bind="selectDialogOptions"
    />
  </div>
</template>

<script>
import {getApproveListService} from "@/services/sysSettingService";
import Consts from "@/utils/consts";
import ApproveDialog from "@/page/meeting/bill/ApproveDialog";
import {
  getTypeListService,
  addSendFileService,
  modifySendFileService,
  getSendDetailService,
} from "@/services/documentServices";
import SelectDialog from "@/page/meeting/bill/SelectDialog";
import SelectAllDialog from "../select-dialog";
import UploadFile from "@/page/document/manage/uploadFile";

export default {
  name: "addAndModiify",
  data(){
    return {
      activeName: 'Tab1',
      documentType: 0, // 1-新增 2-修改
      dataForm:{
        id:'', //id
        title: '',  //标题
        documentNum: '',  //发文字号
        documentTypeId: '',  //发文分类id
        documentDate: '',  //发文日期
        documentDraftDate: '',  //拟稿日期
        documentApproveDate: '',  //核稿日期
        documentDraftDeptJson: [],  //部门
        remark: '',  //备注
        receiveUserId: '106', //接收人
      },
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' },
        ],
        documentDate: [
          { required: true, message: '请选择发文日期', trigger: 'change' },
        ],
        documentDraftDeptJson: [
          { required: true, message: '请选择拟稿部门', trigger: 'change' },
        ],
      },
      fileList:[],


      typeList: [], //发文分类列表

      selectDialogVisible: false,
      selectDialogOptions: {
        departOn: true,
        groupOn: true,
        canSelectDepart: false,
        canSelectUser: true,
        canSelectGroup: false,
        maxSelectedItem: 1,
        dataKey: "sendListJson",
        canSelectAll: true
      },
      selectAllDialogVisible: false,
      btnIndex:1,
    }
  },
  components: {
    SelectDialog,
    SelectAllDialog,
    ApproveDialog,
    UploadFile,
  },
  methods: {
    onActive(menuCode) {
      if(this.tabRouteParam.id){
        this.dataForm.id = this.tabRouteParam.id;
        this.getSendDetail();
      }else {
        this.dataForm.documentNum = this.getCurrentTime();
      }
      this.documentType = this.tabRouteParam.documentType
      this.getTypeList();
    },

    getCurrentTime() {
      let date = new Date();//当前时间
      let year = date.getFullYear() //返回指定日期的年份
      let month = this.repair(date.getMonth() + 1);//月
      let day = this.repair(date.getDate());//日
      let hour = this.repair(date.getHours());//时
      let minute = this.repair(date.getMinutes());//分
      let second = this.repair(date.getSeconds());//秒

      //当前时间
      let curTime = year.toString() + month.toString()  + day.toString() + hour.toString() + minute.toString() + second.toString();
      return curTime;
    },
    //补0
    repair(i){
      if (i >= 0 && i <= 9) {
        return "0" + i;
      } else {
        return i;
      }
    },
    //查询发文分类列表
    getTypeList(){
      let paramsData = {
        pageIndex: 1,
        pageSize: 10000,
      }
      getTypeListService(paramsData).then( res => {
        if(res.code == 10000000){
          this.typeList = res.data;
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    //获取发文详情
    getSendDetail(){
      let paramsData = {
        systemFileInternalId: this.dataForm.id
      }
      getSendDetailService(paramsData).then( res => {
        if(res.code == 10000000){
          this.dataForm = {
            id: res.data.id,
            title: res.data.title,  //标题
            documentNum: res.data.documentNum,  //发文字号
            documentTypeId: res.data.documentTypeId,  //发文分类id
            documentDate: res.data.documentDate,  //发文日期
            documentDraftDate: res.data.documentDraftDate,  //拟稿日期
            documentApproveDate: res.data.documentApproveDate,  //核稿日期
            sendListJson: res.data.sendListJson ? JSON.parse(res.data.sendListJson) : "",  //主送
            ccListJson: res.data.ccListJson ? JSON.parse(res.data.ccListJson) : "",  //抄送
            documentDraftDeptJson: JSON.parse(res.data.documentDraftDeptJson),  //部门
            remark: res.data.remark,  //备注
          }
          this.fileList = res.data.attachmentList;
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    // 删除参会人员
    closeParticipance(tag) {
      let index = this.dataForm.sendListJson.indexOf(tag);
      if (index != -1) {
        this.dataForm.sendListJson.splice(index, 1);
      }
    },
    // 删除列席部门
    closeAttend(tag) {
      let index = this.dataForm.documentDraftDeptJson.indexOf(tag);
      if (index != -1) {
        this.dataForm.documentDraftDeptJson.splice(index, 1);
      }
    },
    // 选择参会人员.可以选择个人，可以选择群组，不可以选择部门
    selectParticipanceList(dataKey) {
      if(dataKey == 'attendDepart'){
        this.selectDialogOptions = {
          departOn: true,
          groupOn: false,
          canSelectDepart: true,
          canSelectUser: false,
          canSelectGroup: false,
          maxSelectedItem: 0,
          dataKey: dataKey
        };
      }else{
        this.selectDialogOptions = {
          departOn: true,
          groupOn: true,
          canSelectDepart: false,
          canSelectUser: true,
          canSelectGroup: true,
          maxSelectedItem: 0,
          dataKey: dataKey
        };
      }
      this.selectDialogVisible = true;
    },
    // 选择部门和人员
    selectDialogClose(data) {
      this.selectDialogVisible = false;
      const { dataKey } = data;
      switch (dataKey) {
        case "attendDepart": // 列席部门
          let departList = data.departList || [];
          departList.forEach(o => {
            let index = this.dataForm.documentDraftDeptJson.findIndex(
                p => p.id == o.id
            );
            if (index == -1) {
              this.dataForm.documentDraftDeptJson.push({
                deptId: o.id,
                name: o.name
              });
            }
          });
          if(this.dataForm.documentDraftDeptJson.length > 1){
            this.$message.error('拟稿部门只能选择一个！');
            this.dataForm.documentDraftDeptJson = [];
          }
          break;
        case "sendListJson": // 主送
          // eslint-disable-next-line
          let userList = data.userList || [];
          // eslint-disable-next-line
          let groupList = data.groupList || [];
          userList.forEach(user => {
            user.meetingType = "user";
          });
          groupList.forEach(group => {
            group.meetingType = "group";
          });
          // eslint-disable-next-line
          let list = userList.concat(groupList);
          list.forEach(o => {
            let index = this.dataForm.sendListJson.findIndex(
                p => p.meetingType == o.meetingType && p.id == o.id
            );
            if (index == -1) {
              this.dataForm.sendListJson.push({
                name: o.displayName|| o.name,
                userId: o.id
              });
            }
          });
          break;

        case "ccListJson": // 抄送
          // eslint-disable-next-line
          let userList1 = data.userList || [];
          // eslint-disable-next-line
          let groupList1 = data.groupList || [];
          userList1.forEach(user => {
            user.meetingType = "user";
          });
          groupList1.forEach(group => {
            group.meetingType = "group";
          });
          // eslint-disable-next-line
          let list1 = userList1.concat(groupList1);
          list1.forEach(o => {
            let index = this.dataForm.ccListJson.findIndex(
                p => p.meetingType == o.meetingType && p.id == o.id
            );
            if (index == -1) {
              this.dataForm.ccListJson.push({
                name: o.displayName|| o.name,
                userId: o.id
              });
            }
          });
          break;

        default:
          break;
      }
    },

    // 选择接收人
    selectReceiveUserIdList(){
      this.selectDialogOptions = {
        departOn: true,
        groupOn: false,
        canSelectDepart: true,
        canSelectUser: false,
        canSelectGroup: false,
        maxSelectedItem: 0,
        dataKey: 'dept'
      };
      this.btnIndex = 1;
      this.selectAllDialogVisible = true;
    },
    // 设置btnIndex
    setBtnIndex(index){
      if(index == 1){
        this.selectDialogOptions = {
          departOn: true,
          groupOn: false,
          canSelectDepart: true,
          canSelectUser: false,
          canSelectGroup: false,
          maxSelectedItem: 0,
          dataKey: 'dept'
        };
      }else {
        this.selectDialogOptions = {
          departOn: true,
          groupOn: true,
          canSelectDepart: false,
          canSelectUser: true,
          canSelectGroup: true,
          maxSelectedItem: 0,
          dataKey: 'user'
        };
      }
      this.btnIndex = index;
    },
    selectAllDialogClose(data) {
      this.selectAllDialogVisible = false;
      const { dataKey } = data;
      console.log(data)

      switch (dataKey) {
        case "dept": // 列席部门
          let departList = data.departList || [];
          departList.forEach(o => {
            let index = this.dataForm.documentDraftDeptJson.findIndex(
                    p => p.id == o.id
            );
            if (index == -1) {
              this.dataForm.documentDraftDeptJson.push({
                deptId: o.id,
                name: o.name
              });
            }
          });
          if(this.dataForm.documentDraftDeptJson.length > 1){
            this.$message.error('拟稿部门只能选择一个！');
            this.dataForm.documentDraftDeptJson = [];
          }
          break;
        case "user": // 主送
          // eslint-disable-next-line
          let userList = data.userList || [];
          // eslint-disable-next-line
          let groupList = data.groupList || [];
          userList.forEach(user => {
            user.meetingType = "user";
          });
          groupList.forEach(group => {
            group.meetingType = "group";
          });
          // eslint-disable-next-line
          let list = userList.concat(groupList);
          list.forEach(o => {
            let index = this.dataForm.sendListJson.findIndex(
                    p => p.meetingType == o.meetingType && p.id == o.id
            );
            if (index == -1) {
              this.dataForm.sendListJson.push({
                name: o.displayName|| o.name,
                userId: o.id
              });
            }
          });
          break;

        case "ccListJson": // 抄送
          // eslint-disable-next-line
          let userList1 = data.userList || [];
          // eslint-disable-next-line
          let groupList1 = data.groupList || [];
          userList1.forEach(user => {
            user.meetingType = "user";
          });
          groupList1.forEach(group => {
            group.meetingType = "group";
          });
          // eslint-disable-next-line
          let list1 = userList1.concat(groupList1);
          list1.forEach(o => {
            let index = this.dataForm.ccListJson.findIndex(
                    p => p.meetingType == o.meetingType && p.id == o.id
            );
            if (index == -1) {
              this.dataForm.ccListJson.push({
                name: o.displayName|| o.name,
                userId: o.id
              });
            }
          });
          break;

        default:
          break;
      }
    },

    // 修改附件列表后的回调
    doSubmitFiles(files) {
      console.log("doSubmitFiles====", files);
      this.fileList = files;
    },
    selectApproveTarget(item) {
      // 选择对应的审批人
      this.approveDialogOptions = {
        approveVO: item,
      };
      this.approveDialogVisible = true;
    },
    approveDialogClose(data) {
      console.log("审批流程,关闭", data);
      this.approveDialogVisible = false;
      if (data) {
        // 选了人了
        this.approveList.forEach((item) => {
          if (item.jobId == data.jobId) {
            item.approveUserId = data.id;
            item.approveUserName = data.displayName || data.name;
            item.deptId = data.deptId;
            item.deptName = data.deptDisplayName;
            // item.jobId = data.jobId;
            // item.jobName = data.jobName;
          }
        });
      }
    },
    submitForm(){
      if(!this.dataForm.title){
        this.$message.error('请输入标题！');
        return
      }
      if(!this.dataForm.documentDate){
        this.$message.error('请选择发文日期！');
        return
      }
      if(this.dataForm.documentDraftDeptJson.length == 0){
        this.$message.error('请选择拟稿部门！');
        return
      }
      // if(this.fileList.length == 0){
      //   this.$message.error('请选择上传附件！');
      //   return
      // }

      if(this.documentType == 1){
        this.preserve();
      }else{
        this.modify();
      }
    },
    //保存
    preserve(){
      let params = {
        ...this.dataForm,
        // sendListJson: this.dataForm.sendListJson.length != 0? JSON.stringify(this.dataForm.sendListJson): '',
        // ccListJson: this.dataForm.ccListJson.length != 0? JSON.stringify(this.dataForm.ccListJson) : '',
        documentDraftDeptJson: JSON.stringify(this.dataForm.documentDraftDeptJson),
        attachmentList: this.fileList,
      }
      addSendFileService(params).then( res => {
        if(res.code == 10000000){
          this.$message.success('新增成功！');
          this.close();
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },
    // 修改
    modify(){
      let params = {
        ...this.dataForm,
        sendListJson: JSON.stringify(this.dataForm.sendListJson),
        ccListJson: JSON.stringify(this.dataForm.ccListJson),
        documentDraftDeptJson: JSON.stringify(this.dataForm.documentDraftDeptJson),
        attachmentList: this.fileList,
      }
      modifySendFileService(params).then( res => {
        if(res.code == 10000000){
          this.$message.success('修改成功！');
          this.close();
        }else{
          this.$message.error(res.msg);
        }
      }).catch(error => {
        this.$message.error("网络请求失败");
      });
    },

    // 关闭按钮
    close(){
      if(this.documentType == 1 ){
        this.bus.$emit("tabClose", "documentManageAdd");
        this.bus.$emit("navMenuChange", {
          routeId: "documentManage"
        });
      }else {
        this.bus.$emit("tabClose", "documentManageModiify");
        this.bus.$emit("navMenuChange", {
          routeId: "documentManage"
        });
      }

    },
  }
}
</script>

<style scoped lang="scss">
  @import "@/assets/css/commonLayout.scss";
  .addAndModify {
    height: 100%;
    background-color: white;
    display: flex;
    flex-direction: column;
    .tabWrap {
      height: calc(100% - 60px);

      /deep/ .el-tabs--top {
        height: 100%;
        overflow: hidden;

        .el-tabs__content {
          height: calc(100% - 140px);
          padding: 0 20px 20px;
          overflow: auto;

          .el-form-item {
            width: 100%;
          }

          .el-checkbox {
            line-height: 40px;
          }

          .el-textarea {
            min-width: 0px !important;
          }
          .el-cascader {
            width: 100%;
          }

          .el-form-item__content {
            width: calc(100% - 150px);

            .el-input {
              width: 100%;
            }
          }
        }
      }
    }
  }
  .sendList {
    /deep/.el-form-item{
      width: 100%;
      display: flex;
      .el-form-item__content {
        width: 80%;
        display: flex;
        .el-input {
          flex: 1;
        }
        .el-button {
          margin-left: 10px;
          height: fit-content;
        }
      }
    }

    .tag-wrapper {
      border: 1px solid #dcdfe6;
      padding: 0 5px;
    }
  }
  .btnMid {
    width: 300px;
    margin: 0 auto;
    display: flex;
    justify-content: space-around;
  }
</style>
